module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_6000.d037dde3.png";